import Joi from "joi";

export const assetTypesSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  assetCategoryId: Joi.string().uuid().required().label("Asset Category"),
  // isDefault: Joi.boolean().label("Is Default"),
});
